import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Podiatry = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my podiatry business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps podiatry businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for podiatry businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most podiatry businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my podiatry business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like podiatry. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Podiatry - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Podiatry CRM", url: "/industries/podiatry" }
  ];

  const industryData = {
    name: 'Podiatry Practice',
    title: 'Fill Your Schedule & Improve Treatment Compliance',
    subtitle: 'Automate appointment reminders, manage diabetic foot check schedules, and reduce no-shows',
    icon: '🦶',
    challenges: [
      'Patients miss follow-up appointments',
      'Diabetic patients forget quarterly checks',
      'High no-show rates',
      'Difficult to track treatment plans',
      'Custom orthotics follow-up is manual'
    ],
    solutions: [
      'Appointment reminder automation',
      'Diabetic check schedule tracking',
      'No-show reduction campaigns',
      'Treatment plan management',
      'Orthotic fitting follow-up'
    ],
    features: [
      'Patient CRM with condition tracking',
      'Automated appointment reminders',
      'Diabetic foot check schedules',
      'Treatment plan tracking',
      'Orthotic order management',
      'Insurance verification',
      'Online booking',
      'Review automation'
    ],
    results: [
      '85% diabetic compliance',
      '45% reduction in no-shows',
      '60% more orthotic sales',
      '5.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Podiatry UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for podiatry businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for podiatry UK, podiatry business software, podiatry customer management, podiatry lead generation UK"
        url="/industries/podiatry"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Podiatry;